import { defineMessages } from 'react-intl';

export const royalMailMessages = defineMessages({
  first_class: {
    id: 'first_class',
    defaultMessage: 'Royal Mail First Class',
  },
  special_delivery: {
    id: 'special_delivery',
    defaultMessage: 'Royal Mail Special Delivery',
  },
  international: {
    id: 'international',
    defaultMessage: 'Royal Mail International Tracked and Signed',
  },
});
